<template>
  <div class="visitor-unavailable">
    <div class="card">
      <van-empty :description="descriptionText" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisitorUnavailable',
  computed: {
    descriptionText () {
      const type = (this.$route && this.$route.query && this.$route.query.type) ? String(this.$route.query.type) : ''
      if (type === 'feature') return '服务商平台访客预约功能未开启'
      if (type === 'reservation') return '预约管理功能未开放'
      return '当前功能暂不可用'
    }
  }
}
</script>

<style lang="scss" scoped>
.visitor-unavailable {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.card {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
</style>
